<template>
    <div class="designeroption" v-if="options_loaded && passed_filter && panel_required">
        <h3>Hinge Qty</h3>
        <div :id="'radio--' + component_id">
            <div v-if="!loading" :data-designer-component-id="component_id" class="radiooption stylesoption">
                <span v-for="option in filtered_option_list" class="full-width">
                    <label>
                        <input type="radio" v-model="localTarget" :name="'radio_' + component_id" :value="option.value"/> {{ option.label }}
                    </label>
                </span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";
    import {nextTick} from "vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Hinge Qty';
                }
            },
            component_id: {
                default(){
                    return 'hinge_qty';
                }
            },
            typeRange: {
              required: true,
            },
            hardwareHandle: {
              required: false,
              default(){
                return 0;
              }
            },
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/collection?question=hinge_qty'  + '&type_range=' + this.typeRange  + '&hardware_handle=' + this.hardwareHandle;
            },
            cache_key(){
                return '_hinge_qty' + '_' + this.typeRange + '_' + this.hardwareHandle;
            },
            panel_required() {
                return this.filtered_option_list.length > 1;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
            'filtered_option_list': function (new_val, old_val) {
                nextTick(()=>{
                    var options = $('#radio--' + this.component_id + ' input').not('.icheck').not('.skip_icheck');

                    options.addClass('icheck').iCheck({
                        checkboxClass: 'checkboxstyle',
                        radioClass: 'radiostyle',
                        selectClass: 'selectstyle'
                    });

                    $('.icheck').iCheck('update');

                    options.on('ifChecked', (e) => {
                        this.localTarget = parseInt(e.target.value);
                    });
                });
            }
        }
    }
</script>
